module.exports = __webpack_public_path__ + "img/accessories.78caf707.jpg";